import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon width="26" height="26" viewBox="0 0 26 26" {...props}>
      <title>{props.title || 'Mood'}</title>
      <g fill="none">
        <path
          d="M2 13C2 6.92487 6.92487 2 13 2H21.5556C22.9056 2 24 3.09442 24 4.44444V13C24 19.0751 19.0751 24 13 24V24C6.92487 24 2 19.0751 2 13V13Z"
          stroke="currentColor"
          strokeWidth="2.6"
        />
        <path
          d="M10.2102 17.3214C14.4467 18.2457 16.1478 17.5091 17.9251 13.8768"
          stroke="currentColor"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
